import { getAppConfigSingleton } from "@expert/app-config";
import { useNotification } from "@expert/common-ui";
import { CopyIcon } from "@expert/common-ui/assets";
import { ActionIcon, CopyButton, Flex, Notification, Text } from "@mantine/core";

import { CheckMark } from "@/common-ui";
import { usePartner } from "@/sdk";
import { classNames } from "@/shared-utils";

import styles from "./EditSessionSummaryModal.module.css";

interface SendSummaryNotification {
    summary: string;
    notificationText: string;
    validAccountNumber: boolean;
}

export function SendSummaryNotification({ validAccountNumber, summary, notificationText }: SendSummaryNotification) {
    const notification = useNotification();
    const partner = usePartner();
    const { requiresManualCopy } = getAppConfigSingleton().getPartnersConfig(partner);

    function getBackgroundClass() {
        return partner === "att" ? styles.brandedBg : styles.defaultBg;
    }

    return (
        <Flex className={classNames(styles.notificationWrapper, getBackgroundClass())}>
            {validAccountNumber && !requiresManualCopy ? (
                <Notification
                    color="dark.0"
                    classNames={{
                        root: styles.notificationRoot,
                    }}
                    radius="sm"
                    withCloseButton={false}
                >
                    <Text fz="xs" lh="lg">
                        {notificationText}
                    </Text>
                </Notification>
            ) : (
                <CopyButton value={summary}>
                    {({ copied, copy }) => {
                        const handleCopyClick = () => {
                            copy();
                            notification.success("Session summary copied to clipboard");
                        };
                        return (
                            <>
                                <Notification
                                    onClick={handleCopyClick}
                                    classNames={{
                                        root: styles.notificationRoot,
                                    }}
                                    color="red.1"
                                    radius="sm"
                                    withCloseButton={false}
                                >
                                    <Text fz="xs" lh="1.125rem">
                                        {notificationText}
                                    </Text>
                                </Notification>
                                <ActionIcon
                                    mr="0.6rem"
                                    color="red.1"
                                    onClick={handleCopyClick}
                                    variant="subtle"
                                    id="copy-summary-action-icon"
                                >
                                    {copied ? (
                                        <CheckMark fill="var(--mantine-color-red-1)" width={18} />
                                    ) : (
                                        <CopyIcon stroke="var(--mantine-color-red-1)" width={17} height={18} />
                                    )}
                                </ActionIcon>
                            </>
                        );
                    }}
                </CopyButton>
            )}
        </Flex>
    );
}
